import {ClosedByPullRequestsReferencesServerQuery} from '@github-ui/server-persisted-queries'
import type {ClosedByPullRequestsReferencesServerQueryQuery} from '@github-ui/server-persisted-queries/types/ClosedByPullRequestsReferencesServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

type QueryNode = NonNullable<ClosedByPullRequestsReferencesServerQueryQuery['node']>
// The generated `node` type is a union of every node type; only the `Issue` member selects the connection.
type IssueNode = Extract<QueryNode, {readonly __typename: 'Issue'}>
type ClosedByPullRequestsReferencesConnection = IssueNode['closedByPullRequestsReferences']

export type ClosedByPullRequestsReferenceNode = NonNullable<
  NonNullable<NonNullable<NonNullable<ClosedByPullRequestsReferencesConnection>['edges']>[number]>['node']
>

export function closedByPullRequestsReferencesQueryKey(owner: string, repo: string, number: number) {
  return ['list-view-items-issues-prs', 'closed-by-pull-requests-references', {owner, repo, number}] as const
}

export async function fetchClosedByPullRequestsReferences(
  owner: string,
  repo: string,
  number: number,
  signal?: AbortSignal,
): Promise<ClosedByPullRequestsReferencesServerQueryQuery> {
  const response = await reactFetchJSON(
    `/${owner}/${repo}/issues/${number}/closed_by_pull_requests_references.json?queryId=${ClosedByPullRequestsReferencesServerQuery}`,
    {signal},
  )
  if (!response.ok) {
    throw new Error(`Closed by pull requests references fetch failed (${response.status})`)
  }

  const json = (await response.json()) as {
    data?: ClosedByPullRequestsReferencesServerQueryQuery
    errors?: unknown[]
  }
  if (json.errors?.length || !json.data) {
    throw new Error('Closed by pull requests references query returned errors')
  }

  return json.data
}
